<template>
	<Loader v-if="loading" />
	<div v-else>

		<div class="content">
			<div class="flex">
				<div class="margin-bottom">
					<select :disabled="loading" v-model="showDate" v-on:change="load()">
						<option value="">Today</option>
						<option :value="dateBack(1)">Yesterday</option>
						<option :value="dateBack(2)">{{ dateBack(2) }}</option>
						<option :value="dateBack(3)">{{ dateBack(3) }}</option>
						<option :value="dateBack(4)">{{ dateBack(4) }}</option>
						<option :value="dateBack(5)">{{ dateBack(5) }}</option>
						<option :value="dateBack(6)">{{ dateBack(6) }}</option>
						<option :value="dateBack(7)">{{ dateBack(7) }}</option>
						<option :value="dateBack(8)">{{ dateBack(8) }}</option>
						<option :value="dateBack(9)">{{ dateBack(9) }}</option>
						<option :value="dateBack(10)">{{ dateBack(10) }}</option>
						<option :value="dateBack(11)">{{ dateBack(11) }}</option>
						<option :value="dateBack(12)">{{ dateBack(12) }}</option>
						<option :value="dateBack(13)">{{ dateBack(13) }}</option>
						<option :value="dateBack(14)">{{ dateBack(14) }}</option>
					</select>
				</div>
				<div class="margin-left">
					<input v-model="filterOk" type="checkbox" />
					Filter approved transactions
				</div>
				<div class="margin-left">
					<input v-model="filterFailedPayment" type="checkbox" />
					Hide orders with failed payment
				</div>
			</div>
		</div>

		<!-- <div class="content">
			<h2 class="small-margin-bottom margin-top">Styling orders</h2>
		</div>
		<Table :columns="stylingColumns" :rows="stylingRows" /> -->

		<!-- <div class="content">
			<h2 class="small-margin-bottom margin-top">Other orders</h2>
			<Table :columns="exchangeColumns" :rows="exchangeRows" />
		</div> -->

		<div class="content">
			<h2 class="small-margin-bottom margin-top">Pending action</h2>
			<Table :columns="pendingActionColumns" :rows="pendingActionRows" />
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    orders: {},
    showDate: '',
    loading: false,
    saving: false,
    filterOk: false,
    filterFailedPayment: false,
    pendingReturnOrders: {}
  }),
  computed: {
    pendingActionColumns () {
      return {
        orderId: {
          name: 'Order'
        },
        state: {
          name: 'Status'
        },
        amount: {
          name: 'Amount'
        },
        failedPayment: {
          name: 'Failed payment'
        },
        created_at: {
          name: 'Created'
        }
      }
    },
    pendingActionRows () {
      var list = {}
      for (var i in this.pendingReturnOrders) {
        var order = this.pendingReturnOrders[i]
        order.orderId = {
          type: 'link',
          url: `${process.env.VUE_APP_WP_URL}/post.php?post=` + order.id + '&action=edit',
          title: order.id
        }

        order.state = order.action_amount ? 'Ready to finalize' : 'Pending action'
        order.amount = order.action_amount
        order.failedPayment = order.hasFailedPayment ? 'Failed payment' : ''

        if (!order.action_amount) {
          // order.menu = [
          // 	{
          // 		name: 'Process with fee',
          // 		onClick: (row) => this.process(row.id, true),
          // 		disabled: this.saving
          // 	},
          // 	{
          // 		name: 'Process without fee',
          // 		onClick: (row) => this.process(row.id, false),
          // 		disabled: this.saving
          // 	}
          // ];
        } else {
          // order.menu = [];
          // order.menu.push({
          // 	name: 'Finalize (Stripe)',
          // 	onClick: (row) => this.finalizeCompleted(row.id, 'stripe'),
          // 	disabled: this.saving || order.hasFailedPayment
          // });
          // order.menu.push({
          // 	name: 'Finalize (Bank payment)',
          // 	onClick: (row) => this.finalizeCompleted(row.id, 'bank'),
          // 	disabled: this.saving || order.hasFailedPayment
          // });

          // order.menu.push({
          // 	name: 'Post credit note',
          // 	onClick: (row) => this.postCompleted(row.id),
          // 	disabled: this.saving
          // });
        }

        list[i] = order
      }
      return list
    },
    exchangeColumns () {
      return {
        id: {
          name: 'Order'
        },
        returnedValue: {
          name: 'Value of returned'
        },
        stripeAmount: {
          name: 'Stripe'
        },
        stripeId: {
          name: 'Stripe ID'
        }
      }
    },
    stylingColumns () {
      return {
        id: {
          name: 'Order'
        },
        value: {
          name: 'Woocommerce'
        },
        totalAmount: {
          name: 'Total'
        },
        stripeAmount: {
          name: 'Stripe Amount'
        },
        bankTransferDate: {
          name: 'Bank transfer'
        },
        refundStripeAmount: {
          name: 'Refunded (Stripe)'
        },
        stripeId: {
          name: 'Stripe ID'
        },
        orderStatus: {
          name: 'Order status'
        },
        comment: {
          name: 'Comment',
          editable: {
            edit: true
          }
        }
      }
    },
    stylingRows () {
      var list = {}
      for (var i in this.orders) {
        var order = {}
        for (var j in this.orders[i]) {
          order[j] = this.orders[i][j]
        }
        if (order.type != 'styling') {
          continue
        }

        var total = Number(order.totalAmount)
        var woocommerce = Number(order.value)

        if (this.filterOk && total == woocommerce) {
          continue
        }

        if (this.filterFailedPayment && order.hasFailedPayment) {
          continue
        }

        if (!order.stripeId) {
          order.fontColor = '#888'
        } else {
          if (woocommerce != total) {
            order.fontColor = 'red'
            order.fontWeight = '900'
          }
        }

        order.commentUrl = '/return-order/' + order.id + '/comment'

        order.id = {
          type: 'link',
          url: `${process.env.VUE_APP_WP_URL}/post.php?post=` + order.id + '&action=edit',
          title: order.id
        }
        order.stripeId = {
          type: 'link',
          url: 'https://dashboard.stripe.com/payments/' + order.stripeId,
          title: order.stripeId
        }
        if (order.refundStripeId) {
          order.refundStripeId = {
            type: 'link',
            url: 'https://dashboard.stripe.com/payments/' + order.refundStripeId,
            title: order.refundStripeId
          }
        }
        list[i] = order
      }
      return list
    },
    exchangeRows () {
      var list = {}
      for (var i in this.orders) {
        var order = this.orders[i]
        if (order.type == 'styling') {
          continue
        }
        order.id = {
          type: 'link',
          url: `${process.env.VUE_APP_WP_URL}/post.php?post=` + order.id + '&action=edit',
          title: order.id
        }
        list[i] = order
      }
      return list
    }
  },
  methods: {
    // postCompleted(id) {
    // 	Vue.api.post('/return-order/' + id + '/post-completed', {}, {
    // 		before: () => this.saving = true,
    // 		always: () => this.saving = false,
    // 		callback: (data) => this.load()
    // 	});
    // },
    // finalizeCompleted(id, source) {
    // 	Vue.api.post('/return-order/' + id + '/finalize-completed', {
    // 		source: source
    // 	}, {
    // 		before: () => this.saving = true,
    // 		always: () => this.saving = false,
    // 		callback: (data) => this.load()
    // 	});
    // },
    // process(id, withFee) {
    // 	Vue.api.post('/return-order/' + id + '/process-completed', {
    // 		withFee: withFee
    // 	}, {
    // 		before: () => this.saving = true,
    // 		always: () => this.saving = false,
    // 		callback: (data) => this.load()
    // 	});
    // },
    load () {
      Vue.api.get('/return-orders?date=' + this.showDate, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.orders = data
      })

      Vue.api.get('/return-orders/pending', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.pendingReturnOrders = data
      })
    },
    dateBack (days) {
      var date = new Date()
      date.setDate(date.getDate() - days)
      var dd = date.getDate()
      var mm = date.getMonth() + 1 // January is 0!

      var yyyy = date.getFullYear()
      if (dd < 10) {
				  dd = '0' + dd
      }
      if (mm < 10) {
				  mm = '0' + mm
      }
      return yyyy + '-' + mm + '-' + dd
    }
  },
  created () {
    this.load()
  }
}
</script>
